import { Controller } from '@hotwired/stimulus'
import Trix from 'trix'

// Connects to data-controller="trix"
export default class extends Controller {
  static targets = ['editor', 'foregroundColorPicker', 'backgroundColorPicker']

  connect () {
    this.initTrix()
    // Attendre que l'éditeur soit prêt avant de tenter de le reset
    setTimeout(() => {
      this.reloadOriginalContent()
    }, 200)
  }

  initTrix () {
    if (this.hasForegroundColorPickerTarget) { return }

    // Configure Trix attributes BEFORE adding buttons
    this.configureTrixAttributes()

    Trix.config.blockAttributes.heading1.tagName = 'h3'
    
    // Attendre que l'éditeur Trix soit complètement chargé
    this.waitForTrixToolbar()
  }

  waitForTrixToolbar () {
    // Essayer de trouver la toolbar toutes les 100ms pendant max 5 secondes
    let attempts = 0
    const maxAttempts = 50
    
    const checkToolbar = () => {
      const textToolsGroup = this.element.querySelector('.trix-button-group.trix-button-group--text-tools')
      
      if (textToolsGroup) {
        this.addCustomButtonsToToolbar()
      } else if (attempts < maxAttempts) {
        attempts++
        setTimeout(checkToolbar, 100)
      }
    }
    
    checkToolbar()
  }

  configureTrixAttributes () {
    // Configure font size text attribute
    Trix.config.textAttributes.fontSize = {
      styleProperty: 'fontSize',
      inheritable: true
    }
  }

  addCustomButtonsToToolbar () {
    this.addForegroundButtonInToolbar()
    this.addBackgroundButtonInToolbar()
    this.addFontSizeButtonsInToolbar()
  }

  reloadOriginalContent () {
    const input = this.element.querySelector('input[type="hidden"]')
    if (input && input.value && this.hasEditorTarget) {
      this.editorTarget.value = input.value
      this.editorTarget.editor.loadHTML(input.value)
    }
  }

  foregroundColor (event) {
    if (this.hasEditorTarget && this.editorTarget.editor) {
      this.editorTarget.editor.activateAttribute('foregroundColor', this.foregroundColorPickerTarget.value)
    }
  }

  backgroundColor (event) {
    if (this.hasEditorTarget && this.editorTarget.editor) {
      this.editorTarget.editor.activateAttribute('backgroundColor', this.backgroundColorPickerTarget.value)
    }
  }

  addForegroundButtonInToolbar () {
    Trix.config.textAttributes.foregroundColor = {
      styleProperty: 'color',
      inheritable: true
    }

    const textToolsGroup = this.element.querySelector('.trix-button-group.trix-button-group--text-tools')
    if (textToolsGroup) {
      textToolsGroup.insertAdjacentHTML('beforeend', this.foregroundColorButtons)
    }
  }

  addBackgroundButtonInToolbar () {
    Trix.config.textAttributes.backgroundColor = {
      styleProperty: 'backgroundColor',
      inheritable: true
    }

    const textToolsGroup = this.element.querySelector('.trix-button-group.trix-button-group--text-tools')
    if (textToolsGroup) {
      textToolsGroup.insertAdjacentHTML('beforeend', this.backgroundColorButtons)
    }
  }

  
  addFontSizeButtonsInToolbar () {
    const textToolsGroup = this.element.querySelector('.trix-button-group.trix-button-group--text-tools')
    if (textToolsGroup) {
      textToolsGroup.insertAdjacentHTML('beforeend', this.fontSizeButtons)
    }
  }
  
  setFontSize(event) {
    event.preventDefault()
    const size = event.currentTarget.dataset.size
    if (this.hasEditorTarget && this.editorTarget.editor && size) {
      // Apply font size directly using CSS
      this.editorTarget.editor.activateAttribute('fontSize', size)
    }
  }


  get foregroundColorButtons () {
    return `
      <span class="trix-button-group trix-button-group--color-tools" data-trix-button-group="color-tools">
        <input id="foreground_color" type="color" class="trix-button trix-button--icon trix-button--icon-color" data-trix-method="foregroundColor" data-trix-attribute="foregroundColor" data-controller="trix" data-action="input->trix#foregroundColor" data-trix-target="foregroundColorPicker" title="Text color">
      </span>
    `
  }

  get backgroundColorButtons () {
    return `
      <span class="trix-button-group trix-button-group--background-color-tools" data-trix-button-group="background-color-tools">
        <input id="background_color" type="color" class="trix-button trix-button--icon trix-button--icon-background-color" data-trix-method="backgroundColor" data-trix-attribute="backgroundColor" data-controller="trix" data-action="input->trix#backgroundColor" data-trix-target="backgroundColorPicker" title="Text background color">
      </span>
    `
  }

  get fontSizeButtons () {
    return `
      <span class="trix-button-group trix-button-group--font-size-tools" data-trix-button-group="font-size-tools">
        <button type="button" class="trix-button trix-button--font-size" data-size="12px" data-action="click->trix#setFontSize" title="12px">12</button>
        <button type="button" class="trix-button trix-button--font-size" data-size="14px" data-action="click->trix#setFontSize" title="14px">14</button>
        <button type="button" class="trix-button trix-button--font-size" data-size="16px" data-action="click->trix#setFontSize" title="16px">16</button>
        <button type="button" class="trix-button trix-button--font-size" data-size="18px" data-action="click->trix#setFontSize" title="18px">18</button>
        <button type="button" class="trix-button trix-button--font-size" data-size="20px" data-action="click->trix#setFontSize" title="20px">20</button>
      </span>
    `
  }

}